module.exports = __webpack_public_path__ + "static/media/M1-24-Congelar-cod133.45738fba.png";